"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeaderboardOptionsSchema = exports.SCORE_LABELS_VALUES = exports.SCORE_SORTING_VALUES = void 0;
exports.validateLeaderboardOptions = validateLeaderboardOptions;
exports.parseLeaderboardOptions = parseLeaderboardOptions;
const zod_1 = require("zod");
exports.SCORE_SORTING_VALUES = ['ASC', 'DESC'];
exports.SCORE_LABELS_VALUES = ['XP', 'KDA', 'POINTS', 'MINUTES'];
exports.LeaderboardOptionsSchema = zod_1.z
    .object({
    encryptionKey: zod_1.z.string().min(1, 'Encryption key cannot be empty'),
    scoreSorting: zod_1.z.enum(exports.SCORE_SORTING_VALUES, {
        message: `Must be one of: ${exports.SCORE_SORTING_VALUES.join(', ')}`,
    }),
    scoreLabel: zod_1.z.enum(exports.SCORE_LABELS_VALUES, {
        message: `Must be one of: ${exports.SCORE_LABELS_VALUES.join(', ')}`,
    }),
    minValue: zod_1.z.number().finite('minValue must be a finite number'),
    maxValue: zod_1.z.number().finite('maxValue must be a finite number'),
    isIncremental: zod_1.z.boolean(),
    cooldownSeconds: zod_1.z.number().int('cooldownSeconds must be an integer').min(0, 'cooldownSeconds must be non-negative'),
})
    .refine((data) => data.minValue < data.maxValue, {
    message: 'minValue must be less than maxValue',
    path: ['minValue'],
});
function validateLeaderboardOptions(input) {
    return exports.LeaderboardOptionsSchema.parse(input);
}
function parseLeaderboardOptions(input) {
    try {
        return exports.LeaderboardOptionsSchema.parse(input);
    }
    catch (_) {
        return null;
    }
}
